import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class PosSharedDataService {
  public paymentDetails: any;

  setPaymentDetails(data: any) {
    this.paymentDetails = data;
  }

  getPaymentDetails() {
    return this.paymentDetails;
  }

  clearPaymentDetails() {
    this.paymentDetails = null; 
  }
}
